import validation from '@/lang/pt/validation';
import literals from '@/lang/pt/literal';

const messages = {
  ...validation,
  ...literals,
};
export default messages;
